export default __webpack_public_path__ + "static/media/icr_envio.3a7805d3.svg";